const REQUEST_TYPE = {
    "Interview": "Entrevista",
    "Visit": "Visita Domiciliar",
    "Document": "Documento",
}

export default REQUEST_TYPE